import ShopDeliveryAddressModelBase from '../_generated/modelBases/shop-delivery-address-model-base';

export default class ShopDeliveryAddressModel extends ShopDeliveryAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
